var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-input-color',{attrs:{"value":_vm.color,"preset-colors":_vm.presetColors,"small":_vm.small,"closeButton":_vm.closeButton},on:{"input":function($event){return _vm.setColor($event)},"menuOpened":function($event){return _vm.$emit('menuOpened', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }